import {useQuery} from "@tanstack/react-query";
import {useParams} from "react-router-dom";
import axios from "../../../axios";
import {getOrdersByEvent} from "./getOrdersByEvent";

export function useGetOrdersByEvent() {
  const {eventId} = useParams<{eventId: string}>();

  return useQuery({
    queryKey: ["ordersByEvent", eventId],
    queryFn: async () => {
      if (!eventId) throw new Error("Event id is required");
      const response = await getOrdersByEvent(
        {data: {eventId: parseInt(eventId)}},
        axios
      );
      return response;
    },
    enabled: !!eventId,
    retry: false,
    throwOnError: true,
  });
}
